var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _debouncedOnChange, _CartItems_instances, onQuantityChange_fn, _handleCartError, _handleCartUpdate, disableCartItems_fn, enableCartItems_fn;
import { C as Component } from "./component-cLJ9vlHA.js";
import { d as debounce, a as lazyReveal, p as prefersReducedMotion, o as onAnimationEnd, f as fetchConfig, b as resetShimmer } from "./utilities-2Suih3Nm.js";
import { m as morphSection, s as sectionRenderer } from "./section-renderer-p3_F8ljj.js";
import { C as CustomEvents, a as CartUpdateEvent, T as ThemeAlertOpenEvent, D as DiscountUpdateEvent } from "./events-DeC3n8dp.js";
import "./critical-Da0Dmhh9.js";
import "./morph-BX9Iqu9G.js";
class CartItems extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CartItems_instances);
    __privateAdd(this, _debouncedOnChange, debounce(__privateMethod(this, _CartItems_instances, onQuantityChange_fn), 300).bind(this));
    __publicField(this, "handleDiscountUpdate", (event) => {
      __privateGet(this, _handleCartUpdate).call(this, event);
    });
    __privateAdd(this, _handleCartError, (line, parsedResponseText) => {
      const quantitySelector = this.refs.quantitySelectors[line - 1];
      const quantityInput = quantitySelector == null ? void 0 : quantitySelector.querySelector("input");
      if (!quantityInput) throw new Error("Quantity input not found");
      quantityInput.value = quantityInput.defaultValue;
      this.dispatchEvent(new ThemeAlertOpenEvent(parsedResponseText.errors, "error"));
    });
    __privateAdd(this, _handleCartUpdate, (event) => {
      var _a, _b;
      const cartHeadingTitleCount = document.querySelector("[data-cart-heading-title-count]");
      const itemCount = (_a = event.detail.data) == null ? void 0 : _a.itemCount;
      if (cartHeadingTitleCount !== null && itemCount !== void 0) {
        cartHeadingTitleCount.classList.toggle("hidden", itemCount === 0);
        cartHeadingTitleCount.innerHTML = itemCount;
      }
      if (event instanceof DiscountUpdateEvent) {
        sectionRenderer.renderSection(this.sectionId, { cache: false });
        return;
      }
      if (event.target === this) return;
      const cartItemsHtml = (_b = event.detail.data.sections) == null ? void 0 : _b[this.sectionId];
      if (cartItemsHtml) {
        morphSection(this.sectionId, cartItemsHtml);
      } else {
        sectionRenderer.renderSection(this.sectionId, { cache: false });
      }
    });
  }
  get section() {
    const section = this.closest("cart-drawer, cart-main") || this;
    return section;
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CustomEvents.cartUpdate, __privateGet(this, _handleCartUpdate));
    document.addEventListener(CustomEvents.discountUpdate, this.handleDiscountUpdate);
    document.addEventListener(CustomEvents.quantitySelectorUpdate, __privateGet(this, _debouncedOnChange));
    lazyReveal(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CustomEvents.cartUpdate, __privateGet(this, _handleCartUpdate));
    document.removeEventListener(CustomEvents.discountUpdate, this.handleDiscountUpdate);
    document.removeEventListener(CustomEvents.quantitySelectorUpdate, __privateGet(this, _debouncedOnChange));
  }
  onLineItemRemove(line) {
    this.updateQuantity({
      line,
      quantity: 0,
      action: "clear"
    });
    const cartItemRowToRemove = this.refs.cartItemRows[line - 1];
    if (!cartItemRowToRemove) return;
    const remove = () => cartItemRowToRemove.remove();
    if (prefersReducedMotion()) return remove();
    cartItemRowToRemove.style.setProperty("--row-height", `${cartItemRowToRemove.clientHeight}px`);
    cartItemRowToRemove.classList.add("removing");
    onAnimationEnd(cartItemRowToRemove, remove);
  }
  updateQuantity(config) {
    __privateMethod(this, _CartItems_instances, disableCartItems_fn).call(this);
    const { line, quantity } = config;
    const { cartSubtotal, cartTotal } = this.section.refs;
    cartSubtotal == null ? void 0 : cartSubtotal.shimmer();
    cartTotal == null ? void 0 : cartTotal.shimmer();
    const sectionsToUpdate = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:sections-to-update", { bubbles: true, detail: { sections: sectionsToUpdate } }));
    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToUpdate,
      sections_url: window.location.pathname
    });
    fetch(`${Theme.routes.cart_change_url}`, fetchConfig("json", { body })).then((response) => {
      return response.text();
    }).then(async (responseText) => {
      var _a;
      const parsedResponseText = JSON.parse(responseText);
      if (parsedResponseText.errors) {
        __privateGet(this, _handleCartError).call(this, line, parsedResponseText);
        return;
      }
      const newSectionHTML = new DOMParser().parseFromString(
        parsedResponseText.sections[this.sectionId],
        "text/html"
      );
      const newCartHiddenItemCount = (_a = newSectionHTML.querySelector('[ref="cartItemCount"]')) == null ? void 0 : _a.textContent;
      const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;
      this.dispatchEvent(
        new CartUpdateEvent({}, this.sectionId, {
          itemCount: newCartItemCount,
          source: "cart-items",
          sections: parsedResponseText.sections
        })
      );
      morphSection(this.sectionId, parsedResponseText.sections[this.sectionId]);
    }).catch((error) => {
      this.dispatchEvent(new ThemeAlertOpenEvent(error, "error"));
    }).finally(() => {
      __privateMethod(this, _CartItems_instances, enableCartItems_fn).call(this);
      resetShimmer(this.section);
    });
  }
  get sectionId() {
    const { sectionId } = this.dataset;
    if (!sectionId) throw new Error("Section id missing");
    return sectionId;
  }
}
_debouncedOnChange = new WeakMap();
_CartItems_instances = new WeakSet();
onQuantityChange_fn = function(event) {
  const { quantity, cartLine: line } = event.detail;
  if (!line) return;
  if (quantity === 0) {
    return this.onLineItemRemove(line);
  }
  this.updateQuantity({
    line,
    quantity,
    action: "change"
  });
  const lineItemRow = this.refs.cartItemRows[line - 1];
  if (!lineItemRow) return;
  const textAnim = lineItemRow.querySelector("text-anim");
  textAnim == null ? void 0 : textAnim.shimmer();
};
_handleCartError = new WeakMap();
_handleCartUpdate = new WeakMap();
disableCartItems_fn = function() {
  this.classList.add("cart-items-disabled");
};
enableCartItems_fn = function() {
  this.classList.remove("cart-items-disabled");
};
if (!customElements.get("cart-items")) {
  customElements.define("cart-items", CartItems);
}
